import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=ec59da40&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=ec59da40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec59da40",
  null
  
)

export default component.exports